import { Schema } from 'normalizr';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { deepKeysToCamel, transformUtil } from 'js-utils/transformation';

import {
    CANNED_QUESTION_EMAIL_ADDRESS,
    CANNED_QUESTION_FIRST_NAME,
    CANNED_QUESTION_LAST_NAME,
    CANNED_QUESTION_HOME_PHONE,
} from '../../containers/checkout/constants';
import { getDeliveryMethodsForCountries } from '../../utils/deliveryMethod';

const orderSchema = new Schema('order');

const _transformAttendeeDeliveryMethodsForCountries = ({
    ticketClass = {},
    ...rest
}) => {
    const { deliveryMethods = [] } = ticketClass;
    const availableDeliveryMethodsForCountries = getDeliveryMethodsForCountries(
        deliveryMethods,
    );

    return {
        ...rest,
        ticketClass: {
            ...ticketClass,
            deliveryMethods: availableDeliveryMethodsForCountries,
        },
    };
};

export const transformOrderData = (data) => {
    // NB: normalizr does a special type of transformation !== deepKeysToCamel,
    // This only affects keys in `order.questions` which are tightly coupled
    // with `order.attendee[n].survey[m].questionId`
    const transformedOrder = transformUtil({
        response: data,
        schema: orderSchema,
    });

    const order = transformedOrder.entities.order[transformedOrder.result];

    return isEmpty(order.attendees)
        ? order
        : {
              ...order,
              attendees: order.attendees.map(
                  _transformAttendeeDeliveryMethodsForCountries,
              ),
              costs: {
                  ...order.costs,
                  feeComponents: deepKeysToCamel(
                      get(data, 'costs.fee_components', []),
                  ),
              },
          };
};

export const transformWaitlistEntryData = (buyerData) => {
    const transformedEntry = {
        firstName: buyerData[CANNED_QUESTION_FIRST_NAME],
        lastName: buyerData[CANNED_QUESTION_LAST_NAME],
        email: buyerData[CANNED_QUESTION_EMAIL_ADDRESS],
    };

    if (buyerData[CANNED_QUESTION_HOME_PHONE]) {
        transformedEntry.phone = buyerData[CANNED_QUESTION_HOME_PHONE];
    }

    return transformedEntry;
};
